



// import React, { useState, useEffect } from "react";
// import "./AaryanBookCar.css";

// export default function AaryanBookCar() {
//   const [showPopup, setShowPopup] = useState(false);

//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     service: "",
//     city: "",
//     otherCity: "",
//     date: "",
//     travellers: "",
//     message: ""
//   });

//   useEffect(() => {
//     setTimeout(() => {
//       setShowPopup(true);
//       document.body.classList.add("popup-open");
//     }, 300);

//     return () => {
//       document.body.classList.remove("popup-open");
//     };
//   }, []);

//   const closePopup = () => {
//     setShowPopup(false);
//     document.body.classList.remove("popup-open");
//   };

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const sendToWhatsApp = () => {
//     const number = "9730707888";

//     const cityValue =
//       form.city === "Other" ? form.otherCity : form.city;

//     const text = `
// Aaryan Travels – Booking Enquiry

// Name: ${form.name}
// Phone: ${form.phone}
// Email: ${form.email}
// Service: ${form.service}
// City: ${cityValue}
// Date: ${form.date}
// Travellers: ${form.travellers}
// Message: ${form.message}
// `;

//     window.open(
//       `https://wa.me/91${number}?text=${encodeURIComponent(text)}`,
//       "_blank"
//     );
//   };

//   if (!showPopup) return null;

//   return (
//     <>
//       <div className="popup-overlay" onClick={closePopup}></div>

//       <div className="popup-container">
//         <button className="popup-close" onClick={closePopup}>✕</button>

//         <h2 className="form-title">
//           Book Your <span>Car</span>
//         </h2>

//         <div className="book-box">

//           {/* ROW 1 */}
//           <div className="form-row two-col">
//             <div className="form-group">
//               <label>Full Name *</label>
//               <input type="text" name="name" placeholder="Enter Full Name" onChange={handleChange} />
//             </div>

//             <div className="form-group">
//               <label>Contact Number *</label>
//               <input type="tel" name="phone" maxLength="10" placeholder="Enter Contact Number" onChange={handleChange} />
//             </div>
//           </div>

//           {/* ROW 2 */}
//           <div className="form-row two-col">
//             <div className="form-group">
//               <label>Email *</label>
//               <input type="email" name="email" placeholder="Enter Email" onChange={handleChange} />
//             </div>

//             <div className="form-group">
//               <label>Select Service *</label>
//               <select name="service" onChange={handleChange}>
//                 <option value="">Select Service</option>
//                 <option>Airport Pickup</option>
//                 <option>Airport Drop</option>
//                 <option>Outstation</option>
//                 <option>Local</option>
//                 <option>Corporate</option>
//               </select>
//             </div>
//           </div>

//           {/* ROW 3 (CITY FIXED) */}
//           <div className={`form-row ${form.city === "Other" ? "two-col" : "one-col"}`}>
//             <div className="form-group">
//               <label>Pick-up City *</label>
//               <select name="city" onChange={handleChange}>
//                 <option value="">Select City</option>
//                 <option>Pune</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Ahmedabad</option>
//                 <option value="Other">Other City</option>
//               </select>
//             </div>

//             {form.city === "Other" && (
//               <div className="form-group">
//                 <label>Enter City Name *</label>
//                 <input type="text" name="otherCity" placeholder="Enter City Name" onChange={handleChange} />
//               </div>
//             )}
//           </div>

//           {/* ROW 4 */}
//           <div className="form-row two-col">
//             <div className="form-group">
//               <label>Travel Date *</label>
//               <input type="date" name="date" onChange={handleChange} />
//             </div>

//             <div className="form-group">
//               <label>No. of Travellers *</label>
//               <input type="number" name="travellers" placeholder="Travellers" onChange={handleChange} />
//             </div>
//           </div>

//           {/* ROW 5 */}
//           <div className="form-row one-col">
//             <div className="form-group">
//               <label>Any Special Requirement *</label>
//               <textarea name="message" placeholder="Message" onChange={handleChange}></textarea>
//             </div>
//           </div>

//           {/* BUTTON */}
//           <div className="button-row">
//             <button onClick={sendToWhatsApp}>Send Enquiry</button>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// }














import React, { useState, useEffect } from "react";
import "./AaryanBookCar.css";

export default function AaryanBookCar() {
  const [showPopup, setShowPopup] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    city: "",
    otherCity: "",
    date: "",
    travellers: "",
    message: "",
  });

  useEffect(() => {
    const popupShown = sessionStorage.getItem("aaryanPopupShown");

    if (!popupShown) {
      setTimeout(() => {
        setShowPopup(true);
        document.body.classList.add("popup-open");
        sessionStorage.setItem("aaryanPopupShown", "true");
      }, 300);
    }

    return () => {
      document.body.classList.remove("popup-open");
    };
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    document.body.classList.remove("popup-open");
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendToWhatsApp = () => {
    const number = "9730707888";

    const cityValue = form.city === "Other" ? form.otherCity : form.city;

    const text = `
Aaryan Travels – Booking Enquiry

Name: ${form.name}
Phone: ${form.phone}
Email: ${form.email}
Service: ${form.service}
City: ${cityValue}
Date: ${form.date}
Travellers: ${form.travellers}
Message: ${form.message}
`;

    window.open(
      `https://wa.me/91${number}?text=${encodeURIComponent(text)}`,
      "_blank"
    );

    closePopup();
  };

  if (!showPopup) return null;

  return (
    <>
      <div className="popup-overlay" onClick={closePopup}></div>

      <div className="popup-container">
        <button className="popup-close" onClick={closePopup}>✕</button>

        <h2 className="form-title">
          Book Your <span>Car</span>
        </h2>

        <div className="book-box">
          {/* ROW 1 */}
          <div className="form-row two-col">
            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Full Name"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Contact Number *</label>
              <input
                type="tel"
                name="phone"
                maxLength="10"
                placeholder="Enter Contact Number"
                onChange={handleChange}
              />
            </div>
          </div>

          {/* ROW 2 */}
          <div className="form-row two-col">
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Select Service *</label>
              <select name="service" onChange={handleChange}>
                <option value="">Select Service</option>
                <option>Airport Pickup</option>
                <option>Airport Drop</option>
                <option>Outstation</option>
                <option>Local</option>
                <option>Corporate</option>
              </select>
            </div>
          </div>

          {/* ROW 3 */}
          <div className={`form-row ${form.city === "Other" ? "two-col" : "one-col"}`}>
            <div className="form-group">
              <label>Pick-up City *</label>
              <select name="city" onChange={handleChange}>
                <option value="">Select City</option>
                <option>Pune</option>
                <option>Mumbai</option>
                <option>Bangalore</option>
                <option>Hyderabad</option>
                <option>Delhi</option>
                <option>Ahmedabad</option>
                <option value="Other">Other City</option>
              </select>
            </div>

            {form.city === "Other" && (
              <div className="form-group">
                <label>Enter City Name *</label>
                <input
                  type="text"
                  name="otherCity"
                  placeholder="Enter City Name"
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          {/* ROW 4 */}
          <div className="form-row two-col">
            <div className="form-group">
              <label>Travel Date *</label>
              <input type="date" name="date" onChange={handleChange} />
            </div>

            <div className="form-group">
              <label>No. of Travellers *</label>
              <input
                type="number"
                name="travellers"
                placeholder="Travellers"
                onChange={handleChange}
              />
            </div>
          </div>

          {/* ROW 5 */}
          <div className="form-row one-col">
            <div className="form-group">
              <label>Any Special Requirement *</label>
              <textarea
                name="message"
                placeholder="Message"
                onChange={handleChange}
              ></textarea>
            </div>
          </div>

          {/* BUTTON */}
          <div className="button-row">
            <button onClick={sendToWhatsApp}>Send Enquiry</button>
          </div>
        </div>
      </div>
    </>
  );
}
